module.exports = __webpack_public_path__ + "img/Expo-Kc-Emotional-Intelligence.0382bd6d.png";